import { useEffect } from "react";

/** Locks page scrolling while the mobile menu or a modal is open. */
export function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return undefined;

    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = overflow;
    };
  }, [locked]);
}

export default useLockBodyScroll;
